import { render, staticRenderFns } from "./SimpleProjectOverview.vue?vue&type=template&id=9774fc30&scoped=true&"
import script from "./SimpleProjectOverview.vue?vue&type=script&lang=ts&"
export * from "./SimpleProjectOverview.vue?vue&type=script&lang=ts&"
import style0 from "./SimpleProjectOverview.vue?vue&type=style&index=0&id=9774fc30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9774fc30",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCheckbox,VCol,VContainer,VDivider,VRow,VSpacer})
